<section class="hd-cheat-sheet-page">
  <hd-cheat-sheet-controls-bar
    [(hideGateNumber)]="hideGateNumber"
    [(hideKeynotes)]="hideKeynotes"
    [(hideColors)]="hideColors"
    [(hideFooterCircuit)]="hideFooterCircuit"
    [(hideFooterChannel)]="hideFooterChannel"
    [(hideBody)]="hideBody"
    [(bodyView)]="bodyView"
    [(colorConfigId)]="colorConfigId"
    [(iconFilters)]="iconFilters"
    [(centerFilters)]="centerFilters"
    [(paintMode)]="paintMode"
    [(paintCenter)]="paintCenter"
    [paintValidation]="paintValidation()"
    (diceClicked)="onShuffleGates()"
    (validatePaintRequested)="onValidatePaint()"
  ></hd-cheat-sheet-controls-bar>

  <hd-cheat-sheet-grid
    [gates]="gates()"
    [hideGateNumber]="hideGateNumber()"
    [hideKeynotes]="hideKeynotes()"
    [hideColors]="hideColors()"
    [paintMode]="paintMode()"
    [paintCenter]="paintCenter()"
    (paintAttempted)="onPaintAttempted()"
    [hideFooterCircuit]="hideFooterCircuit()"
    [hideFooterChannel]="hideFooterChannel()"
    [hideBody]="hideBody()"
    [bodyView]="bodyView()"
    [colorConfig]="colorConfig()"
  ></hd-cheat-sheet-grid>
</section>
